import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import '@/shared/styles/globals.css';

import { App } from './App';

/**
 * 클라이언트 진입점.
 *
 * `index.html`의 `<div id="root">`에 React 19 동시성 모드로 마운트한다.
 * StrictMode는 개발 환경에서 부수효과 누수와 잘못된 사용을 조기 탐지한다.
 */
const rootElement = document.getElementById('root');
if (rootElement === null) {
  throw new Error('루트 엘리먼트(#root)를 찾을 수 없습니다. index.html을 확인하세요.');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
